import React from 'react';
import { CSSProperties } from 'styled-components';
import styles from './style.module.scss';

type ContainerProps = {
  children: React.ReactNode;
  optionalStyles?: CSSProperties;
};

const Container: React.FC<ContainerProps> = ({ children, optionalStyles = {} }) => {
  return (
    <div className={styles['app-page-container']} style={optionalStyles}>
      {children}
    </div>
  );
};

export default Container;
